/* ============================================================
   infinite-scroll.js — Infinite scroll khusus halaman Collection
   (oneluxe.id)

   Cara kerja:
   - Pagination bawaan tema ("Previous | Page 1 of 15 | Next")
     TETAP dirender — bagus untuk SEO & tetap berfungsi kalau
     JavaScript mati — tapi disembunyikan lewat class .is-infinite.
   - Saat pengunjung scroll mendekati bawah grid produk, script
     mengambil halaman berikutnya lewat link "Next" pagination,
     lalu menempelkan kartu produk barunya ke grid yang tampil.
   - Kompatibel dengan filter & sorting bawaan tema: link "Next"
     selalu dibaca ulang dari DOM, jadi parameter filter ikut.
   ============================================================ */
(function () {
  'use strict';

  /* ------- PENGATURAN — sesuaikan bila struktur tema beda ------- */
  var config = {
    grid: '#product-grid',              // container <ul> daftar produk
    item: '.grid__item',                // tiap kartu produk di dalam grid
    pagination: '.pagination-wrapper',  // wrapper pagination bawaan tema
    next: 'a[rel="next"], a.pagination__item--next, ' +
          'a[aria-label*="next" i], a[aria-label*="berikut" i]',
    threshold: 800                      // px sebelum bawah, mulai load
  };

  var busy = false;        // sedang fetch halaman berikutnya
  var disabled = false;    // dimatikan bila struktur tidak cocok
  var sentinel = null;     // elemen pemicu + spinner di bawah grid
  var knownGrid = null;    // referensi grid, untuk deteksi re-render filter
  var loadedUrls = {};     // guard supaya URL yang sama tidak dimuat 2x
  var mutationTimer = null;

  /* ----------------------- util ----------------------- */

  function getGrid(doc) {
    return (doc || document).querySelector(config.grid);
  }

  function getPagination(doc) {
    return (doc || document).querySelector(config.pagination);
  }

  function pageNumberFromUrl(url) {
    var m = String(url || '').match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 1;
  }

  /* Cari URL halaman berikutnya dari markup pagination di DOM */
  function getNextUrl() {
    var pag = getPagination();
    if (!pag) return null;

    /* 1) link "Next" eksplisit (kasus tema kamu) */
    var link = pag.querySelector(config.next);
    if (link && link.href) return link.href;

    /* 2) fallback umum: cari anchor ber-?page= dengan nomor
          terkecil yang lebih besar dari halaman aktif */
    var current = 1;
    var active = pag.querySelector(
      '[aria-current], .pagination__item--current, .current, .is-active'
    );
    if (active) current = parseInt(active.textContent, 10) || 0;
    if (!current) current = pageNumberFromUrl(location.href);

    var best = null;
    var bestNum = Infinity;
    var anchors = pag.querySelectorAll('a[href*="page="]');
    Array.prototype.forEach.call(anchors, function (a) {
      var n = pageNumberFromUrl(a.getAttribute('href'));
      if (n > current && n < bestNum) {
        bestNum = n;
        best = a;
      }
    });
    return best ? best.href : null;
  }

  function hidePaginationIfNeeded() {
    var pag = getPagination();
    if (pag && getNextUrl()) pag.classList.add('is-infinite');
  }

  function showPagination() {
    var pag = getPagination();
    if (pag) pag.classList.remove('is-infinite');
  }

  function nearBottom(el) {
    return el.getBoundingClientRect().top <= window.innerHeight + config.threshold;
  }

  function setSpinner(on) {
    var s = sentinel && sentinel.firstElementChild;
    if (s) s.hidden = !on;
  }

  /* ----------------------- inti ----------------------- */

  function appendItems(newDoc) {
    var curGrid = getGrid();
    var newGrid = getGrid(newDoc);
    if (!curGrid || !newGrid) return -1;

    var items = newGrid.querySelectorAll(config.item);
    Array.prototype.forEach.call(items, function (el) {
      /* buang class animasi on-scroll bawaan tema supaya item
         baru tidak "nyangkut" dalam keadaan transparan */
      el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      el.removeAttribute('data-cascade');
      var animated = el.querySelectorAll('.scroll-trigger');
      Array.prototype.forEach.call(animated, function (a) {
        a.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      });
      curGrid.appendChild(el);
    });
    return items.length;
  }

  function swapPagination(newDoc) {
    var oldPag = getPagination();
    var newPag = getPagination(newDoc);
    if (oldPag && newPag) {
      /* ganti pagination lama dengan milik halaman baru,
         supaya link "Next" otomatis maju ke halaman berikutnya */
      newPag.classList.add('is-infinite');
      oldPag.replaceWith(newPag);
    } else if (oldPag && !newPag) {
      oldPag.remove();
    }
  }

  function loadNext() {
    if (busy || disabled) return;

    var url = getNextUrl();
    if (!url || loadedUrls[url]) return; /* sudah halaman terakhir */

    busy = true;
    setSpinner(true);

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var count = appendItems(doc);

        if (count <= 0) {
          /* Selector tidak cocok dengan struktur halaman.
             Matikan infinite scroll & tampilkan lagi pagination
             biasa supaya pengunjung tetap bisa pindah halaman. */
          disabled = true;
          showPagination();
          return;
        }

        loadedUrls[url] = true;
        knownGrid = getGrid();
        swapPagination(doc);

        /* Opsional: sinkronkan URL di address bar dengan halaman
           terakhir yang dimuat — hapus komentar kalau mau.
        try { history.replaceState(null, '', url); } catch (e) {}
        */
      })
      .catch(function (err) {
        console.warn('[infinite-scroll] gagal memuat halaman berikutnya:', err);
      })
      .then(function () {
        busy = false;
        setSpinner(false);
        /* layar tinggi / grid pendek: kalau sentinel masih
           terlihat, langsung lanjut load halaman berikutnya */
        if (!disabled && sentinel && nearBottom(sentinel)) loadNext();
      });
  }

  /* Dipanggil saat tema me-render ulang grid (filter / sorting) */
  function onExternalRender() {
    var grid = getGrid();
    if (grid && grid !== knownGrid) {
      knownGrid = grid;
      loadedUrls = {};
      disabled = false;
    }
    hidePaginationIfNeeded();
    if (!disabled && sentinel && nearBottom(sentinel)) loadNext();
  }

  function init() {
    var grid = getGrid();
    var pag = getPagination();
    if (!grid || !pag) return; /* koleksi 1 halaman / bukan koleksi */

    knownGrid = grid;
    hidePaginationIfNeeded();

    /* Sentinel: elemen pemicu load + tempat spinner. Ditaruh
       SETELAH container section supaya tidak ikut terhapus saat
       tema me-render ulang grid (filter / sorting). */
    sentinel = document.createElement('div');
    sentinel.className = 'infinite-scroll-status';
    sentinel.innerHTML = '<span class="infinite-scroll-spinner" hidden></span>';

    var anchor =
      document.getElementById('ProductGridContainer') ||
      grid.closest('.collection') ||
      grid;
    anchor.insertAdjacentElement('afterend', sentinel);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          if (entries[0].isIntersecting) loadNext();
        },
        { rootMargin: config.threshold + 'px 0px' }
      ).observe(sentinel);
    } else {
      /* fallback browser lawas */
      window.addEventListener(
        'scroll',
        function () { if (nearBottom(sentinel)) loadNext(); },
        { passive: true }
      );
    }

    /* Pantau re-render dari fitur filter / sort bawaan tema */
    var container =
      document.getElementById('ProductGridContainer') || grid.parentElement;
    if (container && 'MutationObserver' in window) {
      new MutationObserver(function () {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(onExternalRender, 150);
      }).observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
